import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'lohi-internal-dashboard',
  templateUrl: './internal-dashboard.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InternalDashboardComponent implements OnInit {
  constructor() {}

  public ngOnInit(): void {}
}
